import axios from 'axios'
import { AuthDomain } from 'domains/AuthDomain'
import qs from 'qs'

const api = axios.create({
    paramsSerializer: params => {
        return qs.stringify(params, {
            arrayFormat: 'repeat'
        })
    }
})

let logoutInProgress = false

api.interceptors.request.use(
    async config => {
        const authDomain = new AuthDomain()
        await authDomain.makeRefreshToken()
        const token = sessionStorage.getItem('idToken')

        config.headers = config.headers ?? {}

        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
        }

        return config
    },
    error => {
        if (error?.response?.status === 401) {
            const token = sessionStorage.getItem('idToken')

            if (!token) {
                window.location.href =
                    window.location.origin + '/entrar'
            }
        }

        return Promise.reject(error)
    }
)

api.interceptors.response.use(
    response => {
        return response
    },
    async error => {
        const statusCode = error.response?.status
        const is401 = statusCode === 401

        if (is401 && !logoutInProgress) {
            logoutInProgress = true

            const authDomain = new AuthDomain()

            try {
                await authDomain.signOutUser(true)
            } finally {
                logoutInProgress = false
            }
        }

        return Promise.reject(error)
    }
)

export default api